import clsx from 'clsx';
import React from 'react';
import styles from './InputGroupDivider.module.scss';

interface InputGroupDividerProps {
    className?: string;
}

export const InputGroupDivider: React.FC<InputGroupDividerProps> = ({ className }) => {
    return <div className={clsx(styles.root, className)}></div>;
};
